module.exports = "../images/newsletter-banner.jpg?v=01e8bd7";